<template>
    <section class="auto-zahlung">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-lg-12">
              <h2 class="text-align">
                Dein Auto in Zahlung geben und sicher <br>ein neues Auto online kaufen
              </h2>
            </div>
          </div>

          <div class="row teaser-wrap-row">
            <div class="col-xs-12 col-lg-4">
              <div class="teaser-block teaser-block-01 text-align">
                <div class="icon-block">
                  <img
                    src="../assets/icons/garantie.svg"
                    alt="Mit Garantie"
                  />
                </div>
                <h3 class="teaser-title h4">Mit Garantie</h3>
                <p>
                  In einem Angebot von rund 40.000 geprüften Autos findest <br>du dein Wunschfahrzeug mit <span @click="openModal('garantie')">Garantie <i class="fas fa-info-circle" style="cursor:pointer" /></span> und gesetzlich <br>geregeltem 14-tägigen <span @click="openModal('days')">Rückgaberecht <i class="fas fa-info-circle" style="cursor:pointer" /></span>.
                </p>
              </div>
            </div>
            <div class="col-xs-12 col-lg-4">
              <div class="teaser-block teaser-block-02 text-align">
                <div class="icon-block">
                  <img
                    src="../assets/icons/finanzierung.svg"
                    alt="Finanzierung möglich"
                  />
                </div>
                <h3 class="teaser-title h4">Finanzierung möglich</h3>
                <p>
                  Neben dem Barkauf kannst du auch eine individuelle <br>Online-Finanzierung abschließen - und das ohne Anzahlung.
                </p>
              </div>
            </div>
            <div class="col-xs-12 col-lg-4">
              <div class="teaser-block teaser-block-03 text-align">
                <div class="icon-block">
                  <img
                    src="../assets/icons/lieferung.svg"
                    alt="Lieferung kostenlos"
                  />
                </div>
                <h3 class="teaser-title h4">Lieferung kostenlos</h3>
                <p>
                  Dein neues Auto wird <span @click="openModal('lieferung')">kostenlos <i class="fas fa-info-circle" style="cursor:pointer" /></span> bis zu deiner Haustür <br>geliefert. Bei Inzahlungnahme deines Gebrauchtwagens stellen <br>wir deine Mobilität sicher und tauschen Neu gegen Alt.
                </p>
              </div>
            </div>
          </div>

          <div class="row text-align">
            <div class="col-xs-12 col-lg-12">
              <div class="action-block">
                  <a href="https://www.pkw.de/auto-online-kaufen/" title="Zu den Autos im Online-Kauf" target="_blank" class="btn">Zu den Autos im Online-Kauf</a>
              </div>
            </div>
          </div>
        </div>
        <Garantie :isOpen="showModal['garantie']" @close="closeModal('garantie')" />
        <DaysModal :isOpen="showModal['days']" @close="closeModal('days')" />
        <LieferungModal :isOpen="showModal['lieferung']" @close="closeModal('lieferung')" />
    </section>
</template>

<script>
import Garantie from "./modals/GarantieModal.vue";
import DaysModal from "./modals/14DaysModal.vue";
import LieferungModal from "./modals/LieferungModal.vue";
export default {
    name: "AutoZahlung",
    data() {
      return {
        showModal: {
          garantie: false,
          days: false,
          lieferung: false
        },
      }
    },
    components: {
      Garantie,
      DaysModal,
      LieferungModal
    },
    methods: {
      openModal(modalId) {
        this.showModal[modalId] = true;
      },
      closeModal(modalId) {
        this.showModal[modalId] = false;
      },
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";
.auto-zahlung {
    padding-top:25px;
    padding-bottom:30px;

    @include breakpoint(frommediumlarge) {
      padding-top:55px;
      padding-bottom:67px;
    }

    @include breakpoint(fromgiant) {
      padding-top:85px;
      padding-bottom:87px;
    }

    h2 {
      br {
        display:none;

        @include breakpoint(frommediumlarge) {
          display:block;
        }
      }
    }

    .teaser-wrap-row {
        padding-top:10px;

        @include breakpoint(frommediumlarge) {
          padding-top:16px;
        }

        @include breakpoint(fromgiant) {
          padding-top:28px;
        }
    }

    .teaser-block {
      margin-bottom:36px;

      @include breakpoint(frommediumlarge) {
        margin-bottom:56px;
        padding:0 45px;
      }

      @include breakpoint(fromlarge) {
        margin-bottom:0;
        padding:0;
      }
        .icon-block {
            margin-bottom:10px;

            @include breakpoint(frommediumlarge) {
              margin-bottom:30px;
            }

            img {
              width:52px;

              @include breakpoint(frommediumlarge) {
                width:auto;
              }
            }
        }

        .teaser-title {
            margin-bottom:10px;

            @include breakpoint(frommediumlarge) {
              margin-bottom:22px;
            }
        }

        br {
          display:none;

          @include breakpoint(extralarge) {
            display:block;
          }
        }
    }

    .action-block {
        @include breakpoint(fromgiant) {
          padding-top:60px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AutoZahlung.vue